export const handleState = (
  setState,
  value: any,
  name?: string,
  root?: string
) => {
  
  setState((prev) => {
    const temp = { ...prev };
console.log(temp)
    if (!name && !root) {
      return value === "reverse_value" ? !prev : value;
    }

    if (name && root) {
      temp[root][name] = value === "reverse_value" ? !prev[root][name] : value;
    }

    if (name && !root) {
      temp[name] = value === "reverse_value" ? !prev[name] : value;
    }

    return temp;
  });
};

export function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

export const extractNumberFromString = (str) => {
  if (!str) return 0;
  return parseFloat(str?.replace(/[^0-9.]/g, ""));
};
